import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const UserDashboardPostAListingPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/UserDashboardPostAListingPageContainer" */
      './UserDashboardPostAListingPageContainer.dynamic'
    ),
  loading: LoadableLoadingSection,
});
